import { OrientationType } from "react-native-orientation-locker";
export const isPortrait = (o) => o === OrientationType['PORTRAIT'];
//# sourceMappingURL=isPortrait.js.map